export default __webpack_public_path__ + "static/media/opt-trans-white-big.997f53d8.png";